<div style="font-family: 'Open Sans';" *ngIf="!browserControlService.embeddedInXsellerator; else embeddedInXsellerator">
    <svc-work-order-header [transactions$]="appointmentWorkOrder$"
        [toggleTireFinderWidgetValue]="toggleTireFinderWidget"
        (toggleTireFinder)="toggleTireFinder($event)"></svc-work-order-header>

    <div
        class="flex flex-row py-2 h-14 w-full text-base sm:text-lg font-semibold items-center mt-3 bg-white z-auto rounded-lg shadow-lg justify-center">
        <div class="flex justify-center items-center cursor-pointer w-1/3">
            <div class="w-24 sm:w-32 flex flex-col text-center justify-center sm:mx-10"
                [ngClass]="activeTab === 0 && !toggleTireFinderWidget ? 'active-line' : 'text-black border-none'"
                (click)="activeTab = 0; hideTireFinderIfEnabled()">
                Line Items</div>
        </div>
        <span class="border-solid border-l-2 border-grey-400 h-1/2"></span>
        <div class="flex justify-center items-center cursor-pointer w-1/3">
            <div class="w-24 sm:w-32 flex flex-col text-center justify-center sm:mx-10"
                [ngClass]="activeTab === 1 && !toggleTireFinderWidget ? 'active-line' : 'text-black border-none'"
                (click)="activeTab = 1; hideTireFinderIfEnabled()">
                Body Report</div>
        </div>
        <span class="border-solid border-l-2 border-grey-400 h-1/2"></span>
        <div class="flex justify-center items-center cursor-pointer w-1/3">
            <div class="w-24 sm:w-32 flex flex-col text-center justify-center sm:mx-10"
                [ngClass]="activeTab === 2 && !toggleTireFinderWidget ? 'active-line' : 'text-black border-none'"
                (click)="activeTab = 2; hideTireFinderIfEnabled()">
                Inspection</div>
        </div>
    </div>

    <div *ngIf="activeTab === 0" [hidden]="toggleTireFinderWidget">
        <div *ngIf="cases && {mediaParams: mediaParams$ | async} as data">
            <div class="flex flex-row justify-between items-center mt-4"
                (click)="lineItemsCollapsed = !lineItemsCollapsed">
                <span class="text-base font-semibold" style="font-family: 'Open Sans'">Line Items
                    ({{cases.length}})</span>
                <button mat-icon-button>
                    <mat-icon>
                        {{lineItemsCollapsed ? 'keyboard_arrow_down' :'keyboard_arrow_up'}}
                    </mat-icon>
                </button>
            </div>

            <div *ngIf="!lineItemsCollapsed">
                <div *ngFor="let case of cases | orderBy: 'case.sequence';let i = index"
                    class="flex flex-col w-full pb-5 shadow-lg bg-white rounded-lg p-4 mr-1 h-auto mt-2">
                    <div class="flex flex-row place-content-start place-items-start w-full">
                        <span class="text-sm font-semibold border-2 rounded-full text-center w-6 h-6 mr-4"
                            style="font-family: 'Open Sans'; color: #555; border-color: #9747FF; min-width: 1.5rem;">{{case.sequence}}</span>

                        <span class="text-sm font-normal" style="font-family: 'Open Sans'; color: #444;  display: -webkit-box;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            -webkit-line-clamp: 3;
                            -webkit-box-orient: vertical;">
                            <b class="font-semibold"> {{case.labourOp ? case.labourOp : ''}}</b>
                            {{case.labourOp ? ' - ' : ''}} {{case.note}}
                        </span>
                    </div>
                    <div class="flex place-content-start place-items-start mt-3">
                        <sha-media-gallery-dialog-button [media$]="mediaStateService.getWorkOrderCaseMedia(case)">
                        </sha-media-gallery-dialog-button>

                        <sha-media-upload-input class="ml-4"
                            [params]="mediaStateService.buildMediaParams(data?.mediaParams,{caseSequence: case.sequence,caption: case.note, galleryDescription: case.note})">
                        </sha-media-upload-input>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="activeTab === 1" [hidden]="toggleTireFinderWidget">
        <inspection-body-report [printView]=false (onSignatureCompleted)="handleBodyReportSignatureCompleted($event)">
        </inspection-body-report>
    </div>

    <div *ngIf="activeTab === 2" [hidden]="toggleTireFinderWidget">
        <quorum-inspection [transactions$]="appointmentWorkOrder$"></quorum-inspection>
    </div>
</div>
<div class="widget-container h-full w-full pt-4" [hidden]="!toggleTireFinderWidget">
    <!-- Widget will be dynamically inserted here -->
</div>
<ng-template #embeddedInXsellerator>
    <quorum-inspection [transactions$]="appointmentWorkOrder$"></quorum-inspection>
</ng-template>